import { writeLog } from "@common/middleware";

export const writeTerminalLog = (logType, name, text) => (
  writeLog(`${logType.toUpperCase()}|${name}: ${text}`)
);